var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReservation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F2F2F2;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:none;stroke:#006DF0;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st3{fill:#006DF0;}\n\t.st4{fill:none;stroke:#37CE93;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st5{fill:none;stroke:#37CE93;stroke-width:3;stroke-miterlimit:10;stroke-dasharray:27,4;}\n\t.st6{fill:none;stroke:#37CE93;stroke-width:3;stroke-miterlimit:10;}\n\t.st7{fill:none;stroke:#006DF0;stroke-width:3;stroke-miterlimit:10;}\n\t.st8{fill:#37CE93;}\n\t.st9{fill:none;stroke:#37CE93;stroke-width:3;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 50,
    cy: 92,
    rx: 49,
    ry: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.79,
    y: 84.83,
    className: "st1",
    width: 84.42,
    height: 5.97
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M92.21,88.05c0-1.78-1.33-3.22-2.97-3.22H10.76c-1.64,0-2.97,1.44-2.97,3.22v2.75h84.42V88.05z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M13.8,71.64c0-20.05,16.25-36.31,36.31-36.31s36.31,16.25,36.31,36.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M89.36,74.94c0-1.66-1.24-3-2.77-3H13.41c-1.53,0-2.77,1.34-2.77,3v2.56h78.72V74.94z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M21.29,61.58c0,0,4.16-14.07,20.07-19.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M54.26,29.72c1.79,0,3.25-1.37,3.25-3.06c0-1.69-1.45-3.06-3.25-3.06h-8.3c-1.79,0-3.25,1.37-3.25,3.06 c0,1.69,1.45,3.06,3.25,3.06H54.26z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 50.1,
    y1: 29.72,
    x2: 50.1,
    y2: 35.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 50.1,
    y1: 9.2,
    x2: 50.1,
    y2: 17.93
  }), /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 70.39,
    y1: 26.66,
    x2: 61.67,
    y2: 26.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 65,
    y1: 13.16,
    x2: 58.83,
    y2: 19.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 29.74,
    y1: 26.66,
    x2: 38.46,
    y2: 26.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 35.13,
    y1: 13.16,
    x2: 41.3,
    y2: 19.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 54.45,
    y1: 77.5,
    x2: 57.45,
    y2: 84.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 45.75,
    y1: 77.54,
    x2: 42.75,
    y2: 84.88
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_6"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_7"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReservation);
export default __webpack_public_path__ + "static/media/Reservation.53a1fbed84c5c705e67ee9463c57e797.svg";
export { ForwardRef as ReactComponent };